import React from 'react';
import Link, { navigateTo } from 'gatsby-link';
import YellowButtonMD from "./Buttons/YellowButtonMD";
import './NewsPreview.css';

const NewsPreview = (props) => {
    return(
        <div className="col-md-3 news-card" key={props.id} onClick={() => navigateTo(props.path)}>
            <small className="NewsPreview-Date">{props.date}</small>
            <h2 className="news-card-title"><Link to={props.path}>{props.desc}</Link></h2>
            <h3 className="news-card-desc">{props.title}</h3>
            <p>by: {props.author}</p>
            <p className="news-card-content">{props.children}</p>
            <p className="NewsPreview-Button">
                <YellowButtonMD path={props.path} >View Details &raquo;</YellowButtonMD>
            </p>
        </div>
    );
};

export default NewsPreview;


// WEBPACK FOOTER //
// ./src/components/NewsPreview.js